import { ReactComponent as BusinessIcon } from "Components/_Shared/Icons/Assets/business.svg";
import { ReactComponent as ChildIcon } from "Components/_Shared/Icons/Assets/child.svg";
import { ReactComponent as FinancialSuccessIcon } from "Components/_Shared/Icons/Assets/financial-success.svg";
import { ReactComponent as GrandfatherIcon } from "Components/_Shared/Icons/Assets/grandfather.svg";
import { ReactComponent as HomeIcon } from "Components/_Shared/Icons/Assets/home.svg";
import { ReactComponent as RefundIcon } from "Components/_Shared/Icons/Assets/refund.svg";
import { ReactComponent as TargetIcon } from "Components/_Shared/Icons/Assets/target.svg";
import { IncomeIncomeType } from "Infrastructure/ApiZfp/Schema";
import type { ReactNode } from "react";

export const INCOME_TYPE_ORDER: IncomeIncomeType[] = [
  IncomeIncomeType.employment,
  IncomeIncomeType.self_employment,
  IncomeIncomeType.rental,
  IncomeIncomeType.parental,
  IncomeIncomeType.pension,
  IncomeIncomeType.disability,
  IncomeIncomeType.orphan_or_widow_pension,
  IncomeIncomeType.other,
];

export const INCOME_TYPE_ICON: Record<IncomeIncomeType, ReactNode> = {
  [IncomeIncomeType.employment]: <BusinessIcon />,
  [IncomeIncomeType.self_employment]: <FinancialSuccessIcon />,
  [IncomeIncomeType.rental]: <HomeIcon />,
  [IncomeIncomeType.parental]: <ChildIcon />,
  [IncomeIncomeType.pension]: <GrandfatherIcon />,
  [IncomeIncomeType.disability]: <GrandfatherIcon />,
  [IncomeIncomeType.orphan_or_widow_pension]: <RefundIcon />,
  [IncomeIncomeType.other]: <TargetIcon />,
};

/**
 * Maps the API income type onto its key in `Resources.AnalysisDetail.Budget.Incomes.IncomeTypes`.
 * The API values are snake-cased, so they cannot be used as translation keys directly.
 */
export const INCOME_TYPE_TRANSLATION_KEY: Record<
  IncomeIncomeType,
  "Employment" | "SelfEmployment" | "Rental" | "Parental" | "Pension" | "Disability" | "OrphanOrWidowPension" | "Other"
> = {
  [IncomeIncomeType.employment]: "Employment",
  [IncomeIncomeType.self_employment]: "SelfEmployment",
  [IncomeIncomeType.rental]: "Rental",
  [IncomeIncomeType.parental]: "Parental",
  [IncomeIncomeType.pension]: "Pension",
  [IncomeIncomeType.disability]: "Disability",
  [IncomeIncomeType.orphan_or_widow_pension]: "OrphanOrWidowPension",
  [IncomeIncomeType.other]: "Other",
};
